/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Accordion from 'shared/ui/components/Accordion.vue';

const __vue_script__ = {
    name: 'LeadsSettings',

    components: { Accordion },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            registry: {},
            settings: {},
            showCaptureMethods: false,
            loading: true,
            ready: false,
            submitting: false,
            innerValue: {}
        };
    },

    computed: {
        disabled() {
            return this.loading || this.submitting;
        }
    },

    watch: {
        settings: {
            deep: true,
            handler() {
                this.innerValue = { ...this.settings['leads'] };
            }
        }
    },

    async created() {
        await this.loadSettings();
    },

    methods: {
        async loadSettings(skipCache = false) {
            try {
                console.debug('[LeadsSettings] Loading settings');
                const settings = await this.$services.settings.getSettings(this.params.event._id, skipCache ? 0 : 5000);
                const registry = await this.$services.settings.getRegistrySettings(this.params.event._id, 'leads');

                // Check if the universal-lead-capture is installed, i.e. if registry has the key allow_ocr_scanner.
                this.showCaptureMethods = registry.allow_ocr_scanner !== undefined;
                this.registry = registry;
                this.settings = settings;
            } catch (error) {
                console.error('[LeadsSettings] Could not load current settings', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('leads.settings.error_loading').toString(),
                    type: 'error',
                    duration: 15000
                });
            } finally {
                this.loading = false;
                this.ready = true;
            }
        },

        /**
         * Saves the settings.
         */
        async save() {
            try {
                console.info('[LeadsSettings] Saving settings', this.innerValue);
                this.submitting = true;

                await this.$services.settings.saveSetting(this.params.event._id, 'leads', this.innerValue);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('general_settings.messages.settings_save_success').toString(),
                    type: 'success',
                    duration: 5000
                });

            } catch (error) {
                console.error('[LeadsSettings] Error saving settings', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('general_settings.messages.settings_save_failure').toString(),
                    type: 'success',
                    duration: 5000
                });

            } finally {
                this.loadSettings(true);
                this.submitting = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leads-settings"},[_c('div',{staticClass:"content"},[(_vm.ready)?_c('div',{staticClass:"panels panels-b2 view-wrapper"},[_c('div',{staticClass:"panel"},[_c('p',{staticClass:"leads-settings-intro"},[_vm._v(_vm._s(_vm.$t('leads.settings.intro')))]),_c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"leads-settings",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.save)}}},[_c('accordion',{attrs:{"headers-i18n-prefix":"leads","default-open-item":"capture_methods","animated":true,"slim":true},scopedSlots:_vm._u([(_vm.showCaptureMethods)?{key:"capture_methods",fn:function(ref){return [_c('p',[_vm._v(_vm._s(_vm.$t('leads.settings.capture_methods.intro')))]),_c('validation-provider',{attrs:{"slim":true,"name":"allow_qr_scaner"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"allow_qr_scanner","control":_vm.registry.allow_qr_scanner,"settings":_vm.settings,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.allow_qr_scanner),callback:function ($$v) {_vm.$set(_vm.innerValue, "allow_qr_scanner", $$v)},expression:"innerValue.allow_qr_scanner"}})]}}],null,true)}),_c('validation-provider',{attrs:{"slim":true,"name":"allow_ocr_scanner"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"allow_ocr_scanner","control":_vm.registry.allow_ocr_scanner,"settings":_vm.settings,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.allow_ocr_scanner),callback:function ($$v) {_vm.$set(_vm.innerValue, "allow_ocr_scanner", $$v)},expression:"innerValue.allow_ocr_scanner"}})]}}],null,true)}),_c('validation-provider',{attrs:{"slim":true,"name":"allow_manual_input"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"allow_manual_input","control":_vm.registry.allow_manual_input,"settings":_vm.settings,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.allow_manual_input),callback:function ($$v) {_vm.$set(_vm.innerValue, "allow_manual_input", $$v)},expression:"innerValue.allow_manual_input"}})]}}],null,true)})]}}:null,{key:"presentation",fn:function(ref){return [_c('p',[_vm._v(_vm._s(_vm.$t('leads.settings.qualification_page.intro_1')))]),_c('p',[_vm._v(_vm._s(_vm.$t('leads.settings.qualification_page.intro_2')))]),_c('validation-provider',{attrs:{"slim":true,"name":"qualification_page"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"qualification_page","edit":true,"control":_vm.registry.qualification_page,"settings":_vm.settings,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.qualification_page),callback:function ($$v) {_vm.$set(_vm.innerValue, "qualification_page", $$v)},expression:"innerValue.qualification_page"}})]}}],null,true)})]}}],null,true)}),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)]}}],null,false,2882666250)})],1)]):_vm._e()])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LeadsSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__